<div class="k-checkbox">
  <input
    type="checkbox"
    [ngClass]="checkboxClasses"
    [(ngModel)]="isChecked"
    [ngbTooltip]="tooltip | translate"
    (change)="onValueChange(checkbox.checked)"
    #checkbox
    [disabled]="isDisabled"
  />
  <span></span>
  <label
    *ngIf="label && !labelTemplate"
    (click)="checkbox.click()"
    [ngClass]="{ required: isRequired }"
    [class]="labelClasses"
    [innerHTML]="translatedLabel"
  >
  </label>
  <div
    *ngIf="labelTemplate"
    (click)="checkbox.click()"
  >
    <ng-container *ngTemplateOutlet="labelTemplate; context: labelTemplateContext"></ng-container>
  </div>
</div>

<p
  *ngIf="isInvalid"
  class="invalid-feedback"
  [innerHTML]="errorMessage && (errorMessage | translate)"
></p>
